module.exports = __webpack_public_path__ + "img/profit.0356bbf1.png";